// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"450":"a04e8017","808":"3c93f6c8","911":"c0d0b2ff","979":"88697f9e"}[chunkId] + ".css";
};